<template>
  <div class="px-i mb-4">
    <div class="container-fluid px-0">
      <div class="card form-destroy px-i">
        <h3 class="form-destroy-title">
          {{ title }}
        </h3>

        <p class="form-destroy-disclaimer">
          <slot />
        </p>

        <div class="form-destroy-controls">
          <div class="form-destroy-controls-checkbox custom-checkbox">
            <input id="destroy-confirm"
                   v-model="confirmed"
                   class="custom-checkbox-input"
                   type="checkbox">
            <label for="destroy-confirm" class="custom-checkbox-label">
              <span class="custom-checkbox-label-text">{{ labelText }}</span>
            </label>
          </div>
          <button type="button"
                  :disabled="!confirmed"
                  class="btn btn-danger ihjoz-button"
                  @click="clickDestroy($event)">
            {{ buttonTitle }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DestroyDisclaimer',

  props: {
    title: { type: String, required: true },
    labelText: { type: String, required: true },
    buttonTitle: { type: String, default: 'Cancel' }
  },

  data () {
    return {
      confirmed: false
    };
  },

  methods: {
    clickDestroy (e) {
      this.$emit('destroyClick', e);
    }
  }
};
</script>
